import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BadgeSelect from './BadgeSelect';

function Badge(_ref) {
  var size = _ref.size,
      theme = _ref.theme,
      className = _ref.className,
      selectOptions = _ref.selectOptions,
      selectedValue = _ref.selectedValue,
      onSelectChange = _ref.onSelectChange,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["size", "theme", "className", "selectOptions", "selectedValue", "onSelectChange", "children"]);

  var hasSelect = selectOptions && !!selectOptions.length;
  var classes = classnames('tds-badge', className, _defineProperty({
    'tds-badge--sm': size === 'sm',
    'tds-badge--md': size === 'md',
    'tds-badge--lg': size === 'lg',
    'tds-badge--select-container': hasSelect
  }, "tds-badge--color-".concat(theme), theme));
  return hasSelect ? /*#__PURE__*/React.createElement(BadgeSelect, {
    classNames: classes,
    selectOptions: selectOptions,
    value: selectedValue,
    onChange: onSelectChange
  }) : /*#__PURE__*/React.createElement("span", _extends({}, otherProps, {
    className: classes
  }), children);
}

Badge.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  theme: PropTypes.string,
  className: PropTypes.string,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string
  })),
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectChange: PropTypes.func,
  children: function children(props, propName) {
    var childrenPropTypes = {
      children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    };
    var childrenValue = {
      children: props.children
    };

    if (props[propName] === null && props.selectOptions === null) {
      return new Error('A value for `children` or for `selectOptions` is required');
    }

    PropTypes.checkPropTypes(childrenPropTypes, childrenValue, 'prop', 'Badge');
  }
};
Badge.defaultProps = {
  theme: 'fiord',
  size: 'md',
  className: '',
  selectOptions: null,
  selectedValue: undefined,
  onSelectChange: function onSelectChange() {},
  children: null
};
export default Badge;